$(document).ready(function () {
  if ($('.bsub-widget')[0]) {
    $('.subscriptions__price').show();
  } else {
    $('.subscriptions__price').hide();
  }
});
$(window)
  .on('scroll resize', function () {
    var windowScrollTop = $(window).scrollTop();
    var windowInnerHeight = window.innerHeight;

    var $video = $('video');
    var videoTop = $('video').offset().top;

    if ($video[0].paused && windowScrollTop + windowInnerHeight > videoTop) {
      $video[0].play();
    }
  })
  .trigger('scroll');
